<template>
    <div>
        <b-button
            class="btn-checked btn-approved-all"
            v-b-tooltip.hover
            variant="primary-icon-only"
            :title="$t('magazine.approve_completely')"
            @click="onApprove">
        </b-button>

        <design-2021-magazine-approval-wizard-modal-component
            ref="magazine-approval-wizard"
            :magazine-in="magazineIn"
            :current-season="currentSeason">
        </design-2021-magazine-approval-wizard-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-approve-all-pages-component',
    props: ['magazineIn', 'yearbookSettingsIn', 'currentSeason'],
    methods: {
        onApprove() {
            let alreadyFilledOut = false;
            if (this.magazineIn.follow_up_user) {
                alreadyFilledOut = true;
            }

            if (
                this.yearbookSettingsIn.gift_modal_active &&
                !this.$authUser.isAdmin() &&
                !alreadyFilledOut &&
                this.magazineIn.school.school_type !== this.$t('magazine.primary_school') &&
                this.magazineIn.type_id === 2 &&
                this.$authUser.id === this.magazineIn.contact_user_id &&
                this.magazineIn.activeforprint
            ) {
                this.$refs['magazine-approval-wizard'].show();
            } else {
                this.alert
                    .confirm(
                        this.$t('magazine.approve_all_pages'),
                        this.$t('magazine.are_you_sure_you_want_to_approve_all_pages'),
                        this.$t('magazine.yes_approve'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.alert.saving();
                            this.axios.get(this.routes.magazineApproveAllPages(this.magazineIn.id)).then(
                                (response) => {
                                    location.reload();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                        }
                    });
            }
        },
    },
};
</script>

<style scoped></style>
